import Application from "../../Application";
import PaymentConfirmationPresenter, {
  IPaymentConfirmationPresenter
} from "../../presenter/payment/PaymentConfirmationPresenter";
import { IPaymentService } from "../../service/payment/PaymentService";
import { INotificationService } from "../../service/notification/NotificationService";
import { TPaymentConfirmationPresentationModel } from "../../presenter/payment/model/PaymentConfirmationPresentationModel";

export default class ShowPaymentConfirmationInteractor {
  private application: Application;
  private output?: IPaymentConfirmationPresenter;
  private paymentService: IPaymentService;
  private notificationService: INotificationService;

  constructor({
    application,
    paymentService,
    notificationService
  }: {
    application: Application;
    paymentService: IPaymentService;
    notificationService: INotificationService;
  }) {
    this.application = application;
    this.paymentService = paymentService;
    this.notificationService = notificationService;
  }

  async validateToken(token: string) {
    return this.paymentService.validateToken(token);
  }

  async getPaymentConfirmation(shareCode: string) {
    return this.paymentService.getPaymentConfirmation(shareCode);
  }

  execute(shareCode: string) {
    this.output = PaymentConfirmationPresenter({
      application: this.application,
      initialState: {
        payment: {} as TPaymentConfirmationPresentationModel,
        shareCode
      }
    });

    this.getPaymentConfirmation(shareCode)
      .then(this.output?.setPayment)
      .catch((e) => {
        this.notificationService.showError(e.message);
        this.output?.loader.stop("paymentConfirmationLoader");
        throw e;
      });

    return this.output;
  }
}
